/**
 * RecipientStatusBadge — статус получателя рассылки (sent, failed, skipped)
 * Дата: 26.02.2026 — PLAN Manual Broadcasts, Итерация 6
 */
import { cn } from '@/utils/cn';

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  pending: { label: 'Ожидает', className: 'bg-neutral-100 text-neutral-600' },
  sent: { label: 'Отправлено', className: 'bg-green-100 text-green-800' },
  delivered: { label: 'Доставлено', className: 'bg-emerald-100 text-emerald-800' },
  failed: { label: 'Ошибка', className: 'bg-red-100 text-red-800' },
  skipped: { label: 'Пропущено', className: 'bg-amber-100 text-amber-800' },
};

interface RecipientStatusBadgeProps {
  status: string;
  className?: string;
}

export function RecipientStatusBadge({ status, className }: RecipientStatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? { label: status, className: 'bg-neutral-100 text-neutral-600' };
  return (
    <span
      className={cn('inline-flex items-center px-2 py-0.5 rounded text-xs font-medium', config.className, className)}
    >
      {config.label}
    </span>
  );
}
